import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import { Button, InputNumber, Popconfirm, Space, Spin, Table } from 'antd';
import { useEffect, useRef, useState } from 'react';
import fetchApi from '../../../utils/api/fetchApi';
import systemConfig from '../../../config/systematic';
import arrayHandle from '../../../utils/baseLib/arrayHandle';
import antMessage from '../../../utils/extend/AntdNotification';
import { showCustomNotification, useNotificationInstance } from '../../../utils/extend/AntdNotificationEx';

export default function DimSumCategory(props: any) {

    const { data, closeModal } = props;
    const [dimSumCategoryData, setDimSumCategoryData] = useState<any>();
    const [loadingData, setLoadingData] = useState<any>(false);

    const [selectedData, setSelectedData] = useState<any>();
    const [inputVisable, setInputVisable] = useState<any>(false);
    const [inputData, setInputData] = useState<any>();
    const [inputMax, setInputMax] = useState<any>();

    const ref = useRef<any>(undefined);
    const notificationApi = useNotificationInstance();

    /** 后端数据wmService */
    let wmService: any = systemConfig.wmService;

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            wmService = ref.current.wmService;
            // eslint-disable-next-line react-hooks/exhaustive-deps
            // initData = ref.current.initData;
        }
        const fetchData = async () => {
            getShowList();
        }
        fetchData()
    }, [])

    //表头
    const columnsHead = [
        {
            title: '分类',
            dataIndex: 'shopTypeName',
        },
        {
            title: '顺序',
            dataIndex: 'sortBy',
        },

        inputVisable ?
            {
                title: '调整排序',
                dataIndex: 'changeSortBy',
                render: (text: any, record: any) => {
                    if (record.id === selectedData.id) {
                        return (
                            <Space>
                                <InputNumber
                                    max={inputMax}
                                    min={1}
                                    style={{
                                        width: 50,
                                    }}
                                    controls={false}
                                    precision={0}
                                    onChange={(e: any) => handleInput(e)}
                                />
                                <Button onClick={() => handleFinish(inputData)}>确定</Button>
                            </Space>
                        )
                    }
                }
            } : {},

        {
            title: '调整顺序',
            dataIndex: 'sort',
            render: (text: any, record: any, index: any) => {
                return (
                    <Space size="small">
                        <Button size={"small"} type="primary" onClick={() => handleChange(record, "up", index, dimSumCategoryData)}>上</Button>
                        <Button size={"small"} type="primary" onClick={() => handleChange(record, "down", index, dimSumCategoryData)}>下</Button>
                    </Space>
                )
            }
        },

        sessionStorage.getItem('isAdmin') === 'true' ?
            {
                title: '操作',
                dataIndex: 'action',
                render: (text: any, record: any) => {
                    return (
                        <Space>
                            <Popconfirm title="删除该分类下所有菜式菜式,是否执行?" onConfirm={() => handleDel(record)}>
                                <Button type='primary' danger size={"small"}>删除</Button>
                            </Popconfirm>
                        </Space>
                    )
                }
            } : {},
    ];

    const getShowList = () => {
        fetchApi.GET(wmService, {
            apiId: "dimSumCategory",
            apiExtend: 'showList',
            apiData: {
                dimSumHistoryId: data.dimSumHistoryId
            }
        }).then(res => {
            if (res.success) {
                setDimSumCategoryData(res.data);
                if (res.data.length > 1) {
                    setInputMax(res.data[res.data.length - 1].sortBy - 1);
                }
            }
        })
    }

    const handleChange = (record: any, key: any, index: any, rows: any) => {
        let changeData: any = [];
        switch (key) {
            case 'up':
                if (index === 0) {
                    antMessage('error', '当前已在最顶端了', 'error');
                }
                else {
                    changeData.push(
                        {
                            dimSumCategoryId: record.id,
                            sortBy: rows[index - 1].sortBy
                        },
                        {
                            dimSumCategoryId: rows[index - 1].id,
                            sortBy: record.sortBy
                        }
                    )
                }
                break;
            case 'down':
                if (index === rows.length - 1) {
                    antMessage('error', '当前已在最底了', 'error');
                }
                else {
                    changeData.push(
                        {
                            dimSumCategoryId: record.id,
                            sortBy: rows[index + 1].sortBy
                        },
                        {
                            dimSumCategoryId: rows[index + 1].id,
                            sortBy: record.sortBy
                        }
                    )
                }
                break;
        };

        if (changeData.length > 0) {
            setLoadingData(true);
            fetchApi.PUT(wmService, {
                apiId: "dimSumCategory",
                apiExtend: 'changeSortBy',
                apiData: {
                    dimSumHistoryId: data.dimSumHistoryId,
                    changeData
                }
            }).then(res => {
                if (res.success) {
                    getShowList();

                    setSelectedData("");
                    setInputData(0);
                    setInputVisable(false);
                    setLoadingData(false);
                }
            })
        }
    }

    //删除分类下的菜式
    const handleDel = (record: any) => {
        setLoadingData(true);
        fetchApi.PUT(wmService, {
            apiId: "dimSumCategory",
            apiExtend: 'delDimSumDetail',
            apiData: {
                dimSumCategoryId: record.id,
                dimSumHistoryId: data.dimSumHistoryId,
            }
        }).then(res => {
            if (res.success === true) {
                setLoadingData(false);
                getShowList();
            }
        }).catch(err => {
            setLoadingData(false);
            showCustomNotification(notificationApi!, {
                type: 'error',
                message: "错误，无法保存",
                description: err.message + ' | status：' + err.errors.status,
            });
        })
    };

    const handleOk = (e: any) => {
        closeModal(true)
    };

    const dimSumCategorySortBy = (record: any) => {
        setInputVisable(true);
        setInputData(0);
        setSelectedData(record);
    }

    const handleInput = (e: any) => {
        setInputData(e);
    };

    const handleFinish = (e: any) => {
        if (e === 0) {
            antMessage('error', '提交失败', "请输入序号！！");
        }
        else {
            let newData: any = arrayHandle.findData(dimSumCategoryData, "sortBy", e);
            if (newData.length === 0) {
                setLoadingData(true);

                fetchApi.PUT(wmService, {
                    apiId: "dimSumCategory",
                    apiExtend: 'updateSortBy',
                    apiData: {
                        dimSumHistoryId: data.dimSumHistoryId,
                        new_key: e,
                        dimSumCategoryId: selectedData.id
                    }
                }).then(res => {
                    if (res.success) {
                        getShowList();
                        setSelectedData("");
                        setInputVisable(false);
                        setInputData(0);
                        setLoadingData(false);
                    }
                })
            }
            else {
                antMessage('error', '修改失败', "提交的序号，已存在，请重新输入！！");
            }
        }
    };

    return (
        <>
            <AntDraggableModal
                title={'【 ' + data.dimSumHistoryName + ' 】 调整分类顺序'}
                open={true}
                okText='关闭'
                cancelButtonProps={{ style: { display: "none" } }}
                okButtonProps={{ disabled: loadingData }}
                onOk={handleOk}
                closable={false}
                maskClosable={false}
                width={800}>

                {loadingData ? (
                    <Spin size="large" tip="Loading...">
                        <Table
                            pagination={false}
                            size="small"
                            rowKey={(record: any) => record.id}
                            columns={columnsHead}
                            dataSource={dimSumCategoryData}
                        >
                        </Table>
                    </Spin>
                ) :
                    (
                        <Table
                            pagination={false}
                            size="small"
                            rowKey={(record: any) => record.id}
                            columns={columnsHead}
                            dataSource={dimSumCategoryData}
                            onRow={(record) => {
                                return {
                                    onClick: () => dimSumCategorySortBy(record)
                                }
                            }}
                        >
                        </Table>
                    )}

            </AntDraggableModal >
        </>
    )
}